module.exports = __webpack_public_path__ + "img/pole-homepage-bottom-POLAND.1efb226f.webp";